export const licenseKey =
  "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImM0NDcyNWU3LWE3NDctNDQwMi04Y2VhLWNlYjA5MGFhODY0MCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.v1sWDocMS7fs/sg0Ej1fDLHMfFA5LtZ0YCwSj1tnCeaBhoBuD4F3+94uNrDBw50MSalWYnzXDBmgc4YFuD+Dp7kU4OGExx5LLmADc/w2S7APAJasDSK9DvIPk+eVFIayB17Kgg==";
